import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import classes from './InviteUserForm.module.css'
import { useState, useRef } from "react";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { copyIPIOSettings, copyUsersToAnotherDevice, PowerSearchAPI } from "../../Api Methods/Api";
import { useDispatch } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import Lottie from "lottie-react";
import loggingInAnim from '../../assets/animations/newLoading.json'
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import useSetCookie from "../hooks/UseSetCookie";
import { useNavigate } from "react-router-dom";
import { serviceActions } from "../../store/service-Slice";

const CopySiteConfigForm = ({apiData, visible, setIsVisible, siteIdentifier, groups, deviceFromUUID, userID, deviceFromID}) => {

    const [autoSelection, setAutoSelection] = useState(true)
    const [createPortalName, setCreatePortalName] = useState(false)
    const [changeGroup, setChangeGroup] = useState(false)
    const [copyUsers, setCopyUsers] = useState(false)

    const [siteSearchTerm, setSiteSearchTerm] = useState("")
    const siteSearchTermRef = useRef("")
    const [suggestions, setSuggestions] = useState([]);

    const [portalNameText, setPortalNameText] = useState("")
    const [newGroupName, setNewGroupName] = useState("")
    const [siteNameForUsers, setSiteNameForUsers] = useState("")

    const [showLoading, setShowLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [message, setMessage] = useState("Copying site configuration")
    const [failMessage, setFailMessage] = useState("Something went wrong, please try again")
    const [siteCopiedTo, setSiteCopiedTo] = useState("")

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const CopySiteConfig = async () => {
        setIsVisible(false)
        setShowLoading(true)
        const response = await copyIPIOSettings(
            apiData,
            deviceFromUUID,
            autoSelection == false ? siteSearchTermRef.current : "",
            createPortalName == false ? "" : portalNameText,
            changeGroup == false ? "" : newGroupName,
            autoSelection,
            dispatch
        );

        if (response.success){
            const siteData = response.data[0]
            setSiteCopiedTo(siteData)
            if (copyUsers) {
                setMessage("Configuration copy complete, now copying users")
                const usersResponse = await copyUsersToAnotherDevice(
                    apiData, 
                    deviceFromID, 
                    autoSelection == false ? siteSearchTermRef.current : siteData.key,
                    siteNameForUsers != "" ? siteNameForUsers : siteData.key,
                    userID, 
                    dispatch
                );

                if (usersResponse.success) {
                    setMessage("Copy users complete")
                    setShowLoading(false)
                    setShowSuccess(true)
                } else {
                    //failed to copy users
                    setShowLoading(false)
                    setFailMessage(usersResponse.msg)
                    setShowFail(true)
                }
            } else {
                setShowLoading(false)
                setShowSuccess(true)
            }
            
        } else {
            //failed to copy config
            setShowLoading(false)
            setFailMessage(response.msg) 
            console.log(response)
            setShowFail(true)
        }
    }

    const NavigateToSite = () => {
        setShowSuccess(false)
        dispatch(serviceActions.setDeviceUUID(siteCopiedTo.uuid));
        useSetCookie("DeviceUUID", siteCopiedTo.uuid, 1);
        navigate("/Dashboard/SiteView/" + siteCopiedTo.uuid);
        window.location.reload();
    }

    const search = (event) => {
        const powerSearch = async (query) => {
            const reponseData = await PowerSearchAPI(apiData, query, 50, 1, 0, 0, 0, 0, dispatch)
            const suggestedSites = reponseData[0].devices;
            const filteredSites = suggestedSites.filter(site => site.tag === "" && site.userCount === 0);

            const suggestedSiteIDs = filteredSites.map(siteID => siteID.key);
            setSuggestions(suggestedSiteIDs);
            console.log(suggestedSiteIDs)
        }

        powerSearch(event.query)
    };
    
    return (
        <>
        <Dialog
            header={`Copy site configuration of ${siteIdentifier}`}
            visible={visible}
            style={{ width: "40vw", height:"20vw" }}
            onHide={() => setIsVisible(false)}
            contentStyle={{ overflow: "visible" }}
        >
             <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setAutoSelection(!autoSelection)} checked={autoSelection} name='AutoSelection'></Checkbox>
                    <label className="ml-2">   Automatic site selection?</label>
            </div>
            { autoSelection == true && <p style={{fontWeight:"500", fontSize:"14px", color:"#999797", marginTop:"10px"}}>The system will select a site ID with no users that is not named.</p>}
           
            { autoSelection == false && 
                <>
                <br/>
                    <AutoComplete
                        value={siteSearchTerm}
                        suggestions={suggestions}
                        completeMethod={search}
                        onChange={(e) => { setSiteSearchTerm(e.value); siteSearchTermRef.current = e.value; }}
                        placeholder="Type to search..."
                        appendTo="self"
                        panelStyle={{ zIndex: 11000 }}
                    />

                    <p style={{fontWeight:"500", fontSize:"14px", color:"#999797", marginTop:"10px"}}>If a site isn't listed, you can still copy to it by entering its Site ID.</p>

                </>
            }
            
            <Divider type="solid"/>

            <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setCreatePortalName(!createPortalName)} checked={createPortalName} name='CreateName'></Checkbox>
                    <label className="ml-2">   Create Portal name?</label>
            </div>

            {createPortalName === true && (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <br/>
                    <InputText
                        value={portalNameText}
                        onChange={(e) => setPortalNameText(e.target.value)}
                    />
                    <small style={{ color: "#6c757d" }}>
                        This name will be used in the Portal
                    </small>
                </div>
            )}
            <Divider type="solid"/>

            <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setChangeGroup(!changeGroup)} checked={changeGroup} name='ChangeGroup'></Checkbox>
                    <label className="ml-2">   Add to a group?</label>
            </div>
            {changeGroup == true && 
                <>
                    <br/>
                    <div>
                        <Dropdown
                            value={newGroupName}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}
                            onChange={(e) => setNewGroupName(e.value)}
                            options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                            placeholder="Choose group"
                            filter
                            filterPlaceholder="Search groups..."
                        />
                    </div>
                </>
            }

            <Divider type="solid"/>

            <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setCopyUsers(!copyUsers)} checked={copyUsers} name='CopyUsers'></Checkbox>
                    <label className="ml-2">   Copy users?</label>
            </div>

            {copyUsers === true && (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <br/>
                    <InputText
                        value={siteNameForUsers}
                        onChange={(e) => setSiteNameForUsers(e.target.value)}
                    />
                    <small style={{ color: "#6c757d" }}>
                        This name will be used in the mobile app for the copied users
                    </small>
                </div>
            )}


            <Divider type="solid"/>

            <Button 
                severity="success" 
                label="Copy config" 
                onClick={CopySiteConfig}
            />

        </Dialog>

        <Dialog
                header="Please wait..."
                visible={showLoading}
                style={{ width: "40vw" }}
                onHide={() => setShowLoading(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={loggingInAnim}
                        loop={true}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`${message}, please wait...`}</h3>
                    <br />
                    
                </div>
            </Dialog>

            <Dialog
                header="Success"
                visible={showSuccess}
                style={{ width: "35vw" }}
                onHide={() => setShowSuccess(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{ display: "flex", flexDirection:"row", color:"#6e6e6eff", textAlign:"center" }}>{`Site configuration successfully copied to ${siteCopiedTo.key}`}</h3>
                    
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 200, height: 200, margin: "0px" }}
                    />
                    
                    <p style={{ color: "#6e6e6eff" }}>Would you like to go to this site?</p>

                    
                    <br/>
                    <Button label="Yes, take me there" icon="pi pi-times" rounded severity="success" onClick={() => NavigateToSite()} />
                    <br/>
                    <Button label="No, close" icon="pi pi-times" rounded severity="secondary" onClick={() => setShowSuccess(false)} />
                </div>
            </Dialog>

            <Dialog
                header="Error"
                visible={showFail}
                style={{ width: "40vw" }}
                onHide={() => setShowFail(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3 style={{ color: "#6e6e6eff", textAlign:"center" }}>{failMessage}</h3>
<br/>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    
                    <br/>
                    <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setShowFail(false)} />
                </div>
            </Dialog>
        </>
        
    )
}

export default CopySiteConfigForm;